module.exports = __webpack_public_path__ + "img/logo-bootstrap.1e0ee1be.svg";